export const testimonials = [
  {
    id: 1,
    name: "Ana Paula Rodrigues",
    role: "Blogueira de Beleza",
    avatar: "https://public.readdy.ai/ai/img_res/4da7eb4994f307d9b5823e57baef274f.jpg",
    rating: 5,
    comment: "Os produtos desta marca transformaram completamente minha rotina de skincare. O Creme Hidratante Gold é simplesmente incrível — minha pele nunca esteve tão radiante e hidratada!",
    product: "Creme Hidratante Gold",
  },
  {
    id: 2,
    name: "Dra. Mariana Costa",
    role: "Dermatologista",
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20elegant%20Brazilian%20woman%2035%20doctor%20dermatologist%20confident%20warm%20smile%20studio%20lighting%20clean%20background%20testimonial%20photo%20natural%20beauty%20sophisticated%20appearance&width=80&height=80&seq=test2&orientation=squarish",
    rating: 5,
    comment: "Como dermatologista, sou muito criteriosa com os produtos que recomendo. Esta linha skincare utiliza ingredientes de altíssima qualidade e os resultados são visíveis desde a primeira semana.",
    product: "Sérum Vitamina C",
  },
  {
    id: 3,
    name: "Fernanda Lima",
    role: "Maquiadora Profissional",
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20young%20Brazilian%20woman%20makeup%20artist%20beautiful%20smile%20studio%20lighting%20clean%20neutral%20background%20testimonial%20photo%20attractive%20confident%20glowing%20skin&width=80&height=80&seq=test3&orientation=squarish",
    rating: 5,
    comment: "Uso a Paleta Sombras Sunset nos meus clientes e o resultado é sempre impressionante. A pigmentação é excepcional e a durabilidade supera muitas marcas internacionais!",
    product: "Paleta Sombras Sunset",
  },
  {
    id: 4,
    name: "Juliana Mendes",
    role: "Influenciadora Digital",
    avatar: "https://readdy.ai/api/search-image?query=professional%20portrait%20young%20attractive%20Brazilian%20woman%20social%20media%20influencer%20bright%20smile%20natural%20lighting%20clean%20background%20testimonial%20photo%20glowing%20skin%20modern%20beauty&width=80&height=80&seq=test4&orientation=squarish",
    rating: 5,
    comment: "Já testei dezenas de marcas e posso afirmar: esta é a melhor! O Gloss Labial Rose Gold dura o dia todo, hidrata muito e a embalagem é simplesmente linda. Não uso mais nada!",
    product: "Gloss Labial Rose Gold",
  },
];
